import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainLayout from '../../../commons/layout/MainLayout';
import ROUTERS from '../../../commons/constans/router';
import Button from '../../../commons/components/Button';
import PhotoSelector from '../../../commons/components/Forms/PhotoSelector';
import HeaderHs2 from '../../../commons/components/Header/headerHs2';
import { EXCHANGE_POINT, STEPS } from '../../../commons/constans/stepVideo';
import { useDispatch, useSelector } from 'react-redux';
import CouponSelector from '../../../commons/components/Forms/CouponSelector';
import SkeletonLoadingComponent from '../../../commons/components/SkeletonLoading';
import ButtonComponent from '../../../commons/components/Forms/ButtonComponent';
import ModalComponent from "../../../commons/components/Modal/ModalComponent";
import { useExchangeStatus, usePoint } from '../../../commons/customHooks/GiftBox';
import { priceFormat } from '../../../utils/helpers';
import API, { ROUTES } from '../../../commons/api/api';
import { exchangePointToCouponRequest, getCoupon } from '../../Giftbox/redux/actions';
import Loading from '../../../commons/components/Loading';
type Props = {
  pushDataVideoCoupon: Function,
  coupon: Array,
  isProcessing: Boolean,
};

const VideoCouponBoxComponent = ({
  pushDataVideoCoupon,
  coupon,
  isProcessing,
}: Props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [couponPayment, setCouponPayment] = useState([]);
  const [point, isProcessingPoint] = usePoint();
  const [amount, setAmount] = useState(1);
  const [pointExchange, setPointExchange] = useState(EXCHANGE_POINT.VIDEO_PREE);
  const [invalid, setInvalid] = useState(false);
  const [pointCurrent, setPointCurrent] = useState(point);
  const [isShowModalExchange, setIsShowModalExchange] = useState(false);
  const { exchangeStatus, isProcessingExchange } = useSelector(state => state.giftboxReducers);
  const [dataCoupon, setDataCoupon] = useState({
    coupon: {
      coupon_id: null,
      coupon_message_id: null,
      coupon_selected: {},
    },
  });

  useEffect(() => {
    if (exchangeStatus === 200) {
      dispatch(getCoupon());
      setIsShowModalExchange(false)
    }
  }, [exchangeStatus, isProcessingExchange])

  useEffect(() => {
    if (!isProcessingPoint) {
      setPointCurrent(point);
    }
  }, [point, isProcessingPoint])

  useEffect(() => {
    scrollTo(0, 0);
    let _coupon = [];
    coupon.length > 0 &&
      coupon.map((item, idx) => {
        if (item.coupon.coupon_type === 'VIDEO_FREE') {
          _coupon.push(item);
        }
      });
    setCouponPayment(_coupon);
  }, [coupon]);

  useEffect(() => {
    setDataCoupon({
      ...dataCoupon,
      coupon: {
        ...dataCoupon.coupon,
        coupon_id: location.state?.coupon_id || null,
        coupon_message_id: location.state?.coupon_message_id || null,
        coupon_selected: location.state?.coupon_selected || null,
      },
    });
  }, [location.state]);

  const handleChangeCoupon = (e, data) => {
    setDataCoupon({
      ...dataCoupon,
      coupon: {
        ...dataCoupon.coupon,
        coupon_id: data?.coupon_id || null,
        coupon_message_id: data?.id || null,
        coupon_selected: data,
      },
    });
  };

  const onComeBackStep = () => {
    navigate(ROUTERS.VIDEO_MESSAGE_MAKER_STEP_PATH(STEPS.FOUR), {
      state: {
        screen_back: 'coupon_box',
      },
    });
  };
  const handleLeftClick = () => {
    onComeBackStep();
  };

  const onSubmitCoupon = () => {
    dispatch(pushDataVideoCoupon(dataCoupon.coupon));
    onComeBackStep();
  };

  const onExchangeCoupon = () => {
    setIsShowModalExchange(true);
  };

  const renderCoupons = () => {
    if (couponPayment && couponPayment.length > 0) {
      return couponPayment.map((item, idx) => (
        <div className="coupon-image" key={item?.id}>
          <CouponSelector
            id={`${item.id}`}
            name={`input_coupon`}
            value={item?.id || ''}
            path={
              item?.admin_id != null
                ? `/images/img_coupon02.svg`
                : `/images/img_coupon03_1.svg`
            }
            style={false}
            mutiple={false}
            // expired_at={item?.expired_at || ''}
            // coupon_type={item?.coupon?.coupon_type || ''}
            checked={dataCoupon?.coupon?.coupon_message_id == item?.id}
            handleChange={handleChangeCoupon}
            data={item}
            close={false}
          />
        </div>
      ));
    } else {
      return (
        <div className="text-center user-not-coupon">
          <div className="image">
            <img src="/images/img_notfound.svg" alt="" />
          </div>
          <div className="content">
            <h3>사용가능한 쿠폰이 없어요</h3>
          </div>
        </div>
      );
    }
  };

  const handleCloseExchangePoint = () => {
    setAmount(1);
    setIsShowModalExchange(false);
  };

  const handleChangeAmount = (type) => {
    let _amount = amount;
    if (type === 'minus') {
      _amount--
      setAmount(+_amount > 0 ? _amount : 1)
    }else{
      if (invalid) return;
      _amount++
      setAmount(+_amount > 0 ? _amount : 1)
    }
  }

  useEffect(() => {
    console.log(EXCHANGE_POINT.VIDEO_PREE,amount,pointCurrent, 'EXCHANGE_POINT.VIDEO_PREE');
    setPointExchange(amount* +EXCHANGE_POINT.VIDEO_PREE);
    checkValidate(amount* +EXCHANGE_POINT.VIDEO_PREE);
  }, [amount])

  const checkValidate = (value) => {
    console.log(+value, +pointCurrent);
      if (+value > +pointCurrent) {
        console.log(+value, +pointCurrent);
        setInvalid(true);
      }else{
        setInvalid(false);
      }
  }

  const handleExchange = () => {
    let formData = {
      qty: amount,
      coupon_type: 'VIDEO_FREE'
    }
    dispatch(exchangePointToCouponRequest(formData))
    
  }

  return (
    <MainLayout pageID={'video-coupon'} displayBottomNav={false}>
      <HeaderHs2
        labelRight={false}
        labelLeft={true}
        title="쿠폰함"
        handleLabelLeft={() => handleLeftClick()}
      />
      <div
        className={`coupon marker-background ${
          coupon.length <= 0 ? 'coupon-empty' : ''
        }`}
      >
        {isProcessing ? (
          <SkeletonLoadingComponent height={130} />
        ) : (
          <>{renderCoupons()}</>
        )}
      </div>

      {couponPayment.length > 0 ? (
        <div className="coupon-button">
          <ButtonComponent
            label={`사용하기`}
            handleClick={() => onSubmitCoupon()}
            type={`button`}
            cssClass={`btn-custom`}
            disabled={dataCoupon?.coupon?.coupon_message_id ? false : true}
          />
        </div>
      ) : (
        <div className="coupon-button">
          <ButtonComponent
            label={`쿠폰 교환하기`}
            handleClick={() => onExchangeCoupon()}
            type={`button`}
            cssClass={`btn-custom`}
            // disabled={dataCoupon?.coupon?.coupon_message_id ? false : true}
          />
        </div>
      )}

      <ModalComponent
        id={'js-exchange-coupon'}
        show={isShowModalExchange}
        heading={true}
        title={'쿠폰교환'}
        closeButton={true}
        handleClose={handleCloseExchangePoint}
        swipeDown={false}
        type={'style-1'}
      >
        <div className="main-change-to-coupon">
          <div className="card-change-to-coupon">
            <img className='bg-card-coupon'
                           src={`/images/couponbg01_popup.svg`}
                      />
            <div className="info-card">
              <img src="/images/video_point.svg" />
              <div className="type-change">
                <p>영상편지 무료 1회권</p>
                <p>5,000Point / 1개</p>
              </div>
            </div>
          </div>

          <div className='quantity-change'>
            <label>쿠폰 수량</label>
            <div className='quantity-change__value'>
                <div className='item-value'>
                {/* //onClick={()=>actionPayPoint('minus')} */}
                    <label className={`item-value__action `} onClick={() => handleChangeAmount('minus')}> 
                    {/* ${quantityOrderPoint == 1 ? ' opacity-5' : ''} */}
                        <i className={`fas fa-minus`}></i>
                    </label>
                    {/* {quantityOrderPoint} */}
                    <label className='item-value__number'>{amount|| 1}</label>
                    {/* onClick={()=>actionPayPoint('plus')} */}
                    <label className='item-value__action'  onClick={() => handleChangeAmount('plus')}>
                        <i className="fas fa-plus"></i>
                    </label>
                </div>
            </div>
        </div>

          <div className="info-point">
            <div className="info-point__hold info-point__item">
              <label className="info-point-label">보유 포인트</label>
              <label className="info-point-value">{priceFormat(pointCurrent)}P</label>
            </div>

            <div className="info-point__pay info-point__item">
              <label className="info-point-label">결제 포인트</label>
              <label className="info-point-value">{priceFormat(pointExchange)}P</label>
            </div>
          </div>

          {
            pointExchange > point && <div className="alert-point-over">
            <div className="alert-point-over-item">
              <img src="/images/icon_point_popup.svg" />
              <label>보유 포인트가 부족합니다.</label>
            </div>
          </div>
          }
          
          <div className={`btn-change-to-coupon`}>
            <button className="btn" onClick={() => handleExchange()} disabled={pointExchange > pointCurrent ? true: false}>교환하기</button>
          </div>
        </div>
      </ModalComponent>
      
      {
        isProcessingExchange && <Loading />
      }
    </MainLayout>
  );
};

export default VideoCouponBoxComponent;
